import { Button, Card, Flex, Input, Space, Table } from 'antd';
import VoucherModal from 'components/voucher/add-edit';

const { Search } = Input;

const VoucherListDesktop = ({ viewModel }) => {
  const {
    data,
    isModalOpen,
    voucherID,
    setIsModalOpen,
    openVoucher,
    onSearch,
    onSearchChange,
    onVoucherSaved,
    columns,
  } = viewModel;

  return (
    <>
      <Space direction='vertical' size={16} style={{ width: '100%' }}>
        <Card style={{ width: '100%' }}>
          <Space direction='vertical' size={8} style={{ width: '100%' }}>
            <Search
              placeholder='Voucher'
              onSearch={onSearch}
              style={{ width: '100%' }}
              onChange={onSearchChange}
            />
            <Flex justify='flex-end' style={{ width: '100%' }}>
              <Button type='primary' onClick={() => openVoucher(null)}>Thêm mới</Button>
            </Flex>
          </Space>
        </Card>

        <Card style={{ width: '100%' }}>
          <Table rowKey='id' dataSource={data} columns={columns} />
        </Card>
      </Space>

      <VoucherModal
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        id={voucherID}
        onSaved={onVoucherSaved}
      />
    </>
  );
};

export default VoucherListDesktop;